import React, { useContext, useEffect, useState } from "react";
import { Container } from "../components/utils";
import { PhrasesContext } from "../context/phrasesContext";
import FooterLayout from "../layouts/FooterLayout";
import Nav from "../layouts/Nav";
import { getTermsAndConditions } from "../services/Common";

const TermsAndConditions = () => {
  const [lang, setLang] = useState("");
  const [terms, setTerms] = useState("");

  const [enPhrase, arPhrase] = useContext(PhrasesContext);


  const getTermsAndCondition = (currentLang) => {
    return getTermsAndConditions(currentLang).then((res) => {
      setTerms(res);
    });
  };


  useEffect(() => {
    const lang = window.localStorage.getItem("lang");
    let currentLang = lang;
    if (lang === "en") {
      document.body.dir = "ltr";
      setLang("en");
      currentLang = "en";
    } else {
      document.body.dir = "rtl";
      setLang("ar");
      currentLang = "ar";
    }
    getTermsAndCondition(currentLang);
  }, []);

  const changeLanguage2 = (lang) => {
    if (lang === "en") {
      document.body.dir = "rtl";
      setLang("ar");
      window.localStorage.setItem("lang", "ar");
    } else {
      document.body.dir = "ltr";
      setLang("en");
      window.localStorage.setItem("lang", "en");
    }
    window.location.reload();
  };

  const sanitizedHtml = terms.replace(/className/g, "class");
  return (
    <div className="w-full">
      <Nav
        lang={lang}
        enPhrase={enPhrase}
        arPhrase={arPhrase}
        changeLanguage2={changeLanguage2}
      />
      <section
        id="faq"
        className="w-full overflow-hidden bg-gold-10 border-t border-b wow fadeInUp "
      >
        <Container>
     
          <div className="flex flex-col items-center justify-center my-5">
            <h3 className="text-3xl lg:text-4xl text-gray-600 leading-snug font-semibold">
              {lang === "en"
                ? enPhrase["lbl_terms_condtions"]
                : arPhrase["lbl_terms_condtions"]}
            </h3>
          </div>
          <div
            className="text-gray-600 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          ></div>
        </Container>
      </section>
      <FooterLayout
        lang={lang}
        enPhrase={enPhrase}
        arPhrase={arPhrase}
        dashboard
      />
    </div>
  );
};

export default TermsAndConditions;
